module.exports = __webpack_public_path__ + "img/cruves.056dc6c1.svg";